import React from 'react'

function ProcessCards({icon, text, className, classText}) {
  return (
    <div className={`flex flex-row items-center w-100 max-h-1/5 lg:my-auto ${className}`}>
      <img src={icon} alt="ProcessIcon" className="object-contain max-h-20"/>    
      <p className={`px-2 text-lpGray max-w-sm ${classText}`}>{text}</p>
    </div>
  )
}

export default ProcessCards;
